import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Campaign } from 'src/app/api/models/campaign';

@Component({
    selector: 'app-campaign-card',
    templateUrl: './campaign-card.component.html',
    styleUrls: ['./campaign-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignCardComponent implements OnInit {
  @Input() campaign!: Campaign;
  @Input() showAction = false;
  @Input() showDescription = true;
  @Output() toggledCheck = new EventEmitter<void>();

  public checked!: boolean;

  constructor() { }

  ngOnInit(): void {
    this.checked = this.campaign.campanhasStatus.length
      ? this.campaign.campanhasStatus[0].tratado
      : false;
  }
}
